import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ClientModel } from '../../shared/models/client.model';
import { OauthService } from '../../shared/services/oauth.service';
import { CardModel } from '../../shared/models/card.model';
import { CommonHttpService } from '../../shared/services/http.service';
import { Response } from '@angular/http';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'account-cards',
    templateUrl: './account.cards.component.html',
    styleUrls: ['./../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountCardsComponent {
    public cards: Array<CardModel> = [];
    public client: ClientModel;
    public creating = false;
    public loading = false;

    constructor(
        protected titleService: Title,
        protected translate: TranslateService,
        protected http: CommonHttpService,
        protected router: Router,
        protected oauth: OauthService, 
        protected activatedRoute: ActivatedRoute
    ) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.oauth.init();
            }
        });

        this.translate.get('ACCOUNT.CARDS.TITLE').subscribe((title: string) => {
            this.titleService.setTitle(title+ ' | ' + this.activatedRoute.snapshot.data.storeConfigurations.store_name);
        });
        this.oauth.loadedAuthenticatedUser$.subscribe((client: ClientModel) => {
            this.client = client;
            this.indexCards();
        });
        this.oauth.failedAuthenticatedUser$.subscribe((error: Response) => {
            this.redirectOnFailAuthentication(error.status);
        });
        this.oauth.failedPersistedUser$.subscribe((error: Response) => {
            this.redirectOnFailAuthentication(error.status);
        });
        this.oauth.tokenRefused$.subscribe(() => {
            this.redirectOnFailAuthentication();
        });
    }

    /**
     * Index cards from client.
     **/
    public indexCards() {
        this.cards = [];
        this.loading = true;
        this.http
            .useAuth()
            .get(`account/clients/${this.client.id}/cards?_sort=-id`)
            .subscribe((response: Response) => {
                this.cards = response.json().data;
                this.loading = false;
            });
    }

    /**
     * Redirect to store index.
     **/
    private redirectOnFailAuthentication(statusCode = 401) {
        if (statusCode === 401) {
            window.location.href = '/';
        }
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/account/cards/account.cards.component.ts